import React from 'react';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { selectIsGameFavorite } from '../../store/selectors/gamesSelectors';
import { toggleFavoriteGame } from '../../store/thunks/gamesThunks';

import './FavoriteButton.css';

type FavoriteButtonProps = {
  gameId: string;
};

export function FavoriteButton({ gameId }: FavoriteButtonProps) {
  const dispatch = useAppDispatch();
  const isFavorite = useAppSelector(selectIsGameFavorite(gameId));

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    dispatch(toggleFavoriteGame({ gameId }));
  };

  return (
    <button
      className={`favorite-btn${isFavorite ? ' favorite-btn--active' : ''}`}
      onClick={handleClick}
      aria-label={isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}
    >
      {isFavorite ? '❤️' : '🤍'}
    </button>
  );
}
